import { Bubble } from '@ant-design/x';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Spin, Tooltip, Modal, Drawer, message } from 'antd';
import s from './style/chat.module.scss';
import { ConfirmTip } from '@/utils/Web';
import SkillList from '../../PageComponents/SkillList';
import ToastUtils from '@/utils/ToastUtils';
import useChat from '../../../useThirdSkill';
import { inject, observer } from 'mobx-react';
import grtStore from '@/store/grtStore';

import withRouter from '@/components/withRouter';
import PreQuestion from '../../PageComponents/PreQuestion';
import { Display } from '@/components/Display/Display';
import Warning from '@/assets/img/Warning.svg';
// 🔥 新增：导入 useDeerFlowChat hook
import useDeerFlowChat from '../../../hooks/DeerFlow/useDeerFlowChat';
// 🔥 新增：导入 useDeerFlow hook
import useDeerFlow from '../../../hooks/DeerFlow/useDeerFlow';
// 🔥 新增：导入 useBodyScrollControl hook
import useBodyScrollControl from '../../../hooks/DeerFlow/useBodyScrollControl';
// 🔥 新增：导入 useWindowResize hook
import useWindowResize from '../../../hooks/DeerFlow/useWindowResize';
import SessionList from '../../PageComponents/SessionList';
import { getRoles, getUserId, handleStyle } from '@/utils/Page';
import { defaultPageTitle, themeMap, defaultPlugins, third_json_handler } from '@/utils/Page/constant';

import WebSender from '../../PageComponents/WebSender';
import ApartSkillList from '../../PageComponents/ApartSkillList';
// import preImg from '@/assets/images/mobile/pre_icon.webp';
// import Error from '@/components/Web/Error';
import AgentError from '../../PageComponents/AgentError';

import { Hide } from '@/components/Hide';
import ToolList from '../../PageComponents/ToolList';
import { Outlet } from 'react-router-dom';
// import LinkGuide from '../../PageComponents/LinkGuide';
import GrtLoading from '@/components/Web/GrtLoading';
import UserInfo from '../../PageComponents/UserInfo';
import AgentLogo from '../../PageComponents/AgentLogo';

// AI PPT组件
import AIPPTContainer from './AIPPTContainer';
// 导入研究报告组件
import SimpleReportSidebar from '../../PageComponents/SimpleReportSidebar';
import SimpleReportNotice from '../../PageComponents/SimpleReportNotice';
// 导入 DeerFlow 侧边栏组件
import DeerFlowSidebar from './DeerFlowSidebar';
// 导入 DeerFlow 消息处理器函数
import processDeerFlowMessages from './DeerFlowMessageProcessor';
//tts部分
import ToolBar from './roomTTS/ToolBar';
import CameraArea from './roomTTS/CameraArea';
import { useLeave } from '@/libTTS/useCommon';

import AIMarks from '@/components/AiMark';
import Toast from '@/components/Toast';
import ChatBI from './Chats/ChatBi';
import UserCards from '../../PageComponents/CaseSimulation/UserCards';
import CardButton from '../../PageComponents/CaseSimulation/CardButton';
import useTTSHandler from '@/pages/hooks/useTTSHandler';
import { agentTipBgImg } from '@/utils/Page/constant';
import tipHandImg from '@/assets/images/web/tip_hand.webp';
import hiImg from '@/assets/images/hi.webp';
import CircleBlink from '../../PageComponents/CircleBlink';
import { getSearchStr } from '@/utils/Page';
// todo --aippt、deerflow、语音代码太复杂，需要优化
const figureImg = {
    1: require('@/assets/images/web/figure_bg_blue.webp'),
    2: require('@/assets/images/web/figure_bg_red.webp'),
    3: require('@/assets/images/web/figure_bg_green.webp')
};

const WebOutsideChats = (props) => {
    const { ttsMessagesRef, ttsContentRef, TTSNewMsg, TTSNewlist, resetVoiceCallStatus, resetMessageIdState, handleTTSMessageUpdate, isInVoiceCall } =
        useTTSHandler({
            store: props.store
        });
    const listRef = useRef();
    const chatBoxRef = useRef();
    const chatRef = useRef();
    // const skillListRef = useRef([]);

    const chatBIRef = useRef();
    const [style, setStyle] = useState({
        webBgUrl: null,
        h5BgUrl: null,
        themeColor: 1
    });
    const { grtAi, skillStore, simulation, chatStore, sessionStore, preQuestionStore, voiceCallStore, multimodalStore } = props.store;
    // 多模态学习详情面板状态管理（使用全局 store）

    const detailPanelOpen = multimodalStore?.detailPanelOpen;
    const activeDetailMessageId = multimodalStore?.activeMessageId;
    const setDetailPanelOpen = (flag) => {
        if (multimodalStore && typeof multimodalStore.setDetailPanelOpen === 'function') {
            multimodalStore.setDetailPanelOpen(flag);
        }
    };
    const setActiveDetailMessageId = (id) => {
        if (multimodalStore && typeof multimodalStore.setActiveMessageId === 'function') {
            multimodalStore.setActiveMessageId(id);
        }
    };

    // 添加窗口大小状态
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    let userId = getUserId();
    const { agentId, sessionId, toolId } = props.params;

    const { currentAgent = {}, agentLoading } = grtAi.state;
    let { isLogin } = grtAi;
    //tts语言播报控制输入框显示隐藏
    const { isInputVisible, showTTSComponent, showChatInterface, showCameraArea, handleBackToChat, handleTTSToggle } = voiceCallStore;
    const leaveRoom = useLeave();
    let {
        loading,
        content,
        setContent,
        resetSession,
        choseApartSkill,
        startNewMsg,
        onSubmitMsg,
        recordLoading,
        changeSession,
        changeTool,
        clickGuide,
        checkIsLogin,
        agentFile,
        setAgentFile,
        isCanSendMsg,
        handleMessages,
        originMsgMap: originMsgMapRef,
        currentSessionMapId: currentSessionMapIdRef,
        changeSessionMapItem,
        formatSessionList,
        linkToSession,
        handleGetSessionMessage,
        handlePaste,
        getSessionList,
        showAgentTip,
        setShowAgentTip,
        showAgentModal,
        setShowAgentModal,
        initAgentTip
    } = chatStore;
    let {
        isCaseSimulationType,
        originSkillList: skillListRef,
        curPlugin,
        setCurPlugin,
        curSkill,
        setCurSkill,
        skillList,
        getGroupSkillList,
        skillPreQuestion
    } = skillStore;
    let { sessionMap, originSessionList: sessionListRef, changeOriginMsgMap: changeOriginMsgMapRef, originMsgMap } = sessionStore;
    const chatProps = useChat(props);
    const { multimodalReference, setMultimodalReference } = multimodalStore;
    const {
        agentFileRef,
        editPlanMode, // 新增的属性
        toggleEditPlanMode, // 新增的属性
        resetEditPlanMode, // 正确的函数名称
        stopDeerFlow, // 新增的stopDeerFlow函数
        stopHistoryPolling, // 新增的stopHistoryPolling函数
        hideTTSActions,
        setHideTTSActions
    } = chatProps;
    let isCaseSimulation = isCaseSimulationType(curSkill?.ability_id);
    // 🔥 新增：判断当前是否为 DeerFlow 会话
    const isDeerFlowSession = curSkill?.third_json?.handler === third_json_handler?.deerflow;

    // 🔥 新增：使用 useDeerFlow 中的滚动功能
    const { scrollToBottomWithAnimation, getScrollToBottomParams } = useDeerFlow();

    // 🔥 新增：应用滚动到底部的 hook
    const scrollParams = getScrollToBottomParams(sessionMap, currentSessionMapIdRef, listRef);
    useEffect(scrollParams.callback, scrollParams.dependencies);

    // pending interrupt flag to attach to next submit
    const pendingInterruptFeedbackRef = React.useRef(null);

    // 监听来自 ResearchPlanCard 的编辑事件，进入修改方案模式并聚焦输入框
    useEffect(() => {
        const handleResearchPlanEdit = (event) => {
            try {
                if (typeof toggleEditPlanMode === 'function') {
                    toggleEditPlanMode();
                }
                // 聚焦输入框，延迟一点确保输入框已渲染
                setTimeout(() => {
                    const el = document.getElementById('web-send-input');
                    if (el && typeof el.focus === 'function') {
                        el.focus();
                    }
                }, 50);

                // 标记下次发送需要携带 interrupt_feedback
                try {
                    const detail = event && event.detail ? event.detail : {};
                    if (detail.interrupt_feedback) {
                        pendingInterruptFeedbackRef.current = detail.interrupt_feedback;
                    }
                } catch (err) {
                    console.error('set pending interrupt feedback error', err);
                }
            } catch (e) {
                console.error('handleResearchPlanEdit error', e);
            }
        };

        window.addEventListener('research-plan-edit', handleResearchPlanEdit);
        return () => {
            window.removeEventListener('research-plan-edit', handleResearchPlanEdit);
        };
    }, [toggleEditPlanMode]);

    // 🔥 新增：使用 useDeerFlowChat hook 封装所有DeerFlow相关功能
    const deerFlowChatProps = useDeerFlowChat({
        sessionId,
        originMsgMapRef,
        stopDeerFlow,
        stopHistoryPolling,
        detailPanelOpen,
        setDetailPanelOpen,
        activeDetailMessageId,
        setActiveDetailMessageId,
        windowSize,
        isDeerFlowSession
    });

    // 🔥 新增：使用 useBodyScrollControl hook 控制页面滚动行为（仅 DeerFlow 会话）
    useBodyScrollControl(isDeerFlowSession);

    // 🔥 新增：使用 useWindowResize hook 监听窗口大小变化（仅 DeerFlow 会话）
    useWindowResize(setWindowSize, isDeerFlowSession);

    const getHistorySessionList = async () => {
        let data = {
            user_id: userId,
            agent_id: agentId
        };
        getSessionList(data);
    };

    const init = async () => {
        await grtAi.getAgentDetail(agentId);
    };

    useEffect(() => {
        if (agentId) {
            init();
            initAgentTip();
        }
        return () => {
            document.title = defaultPageTitle;
        };
    }, []);

    //处理智能体的会话隔离技能列表
    const handleAngentInfo = async () => {
        let toolList = currentAgent?.scene_tool;
        await getGroupSkillList(currentAgent?.scene_setting, '1', toolList, isLogin);
        document.title = currentAgent?.name || '';
    };
    const getStyle = () => {
        let res = handleStyle(currentAgent?.user_agent_style);
        document.body.setAttribute('data-theme', themeMap[res?.themeColor]);
        setStyle(res);
    };
    useEffect(() => {
        handleAngentInfo();
        getStyle();
    }, [currentAgent, isLogin]);

    const submitMsg = (msgOrParams, isPreQuestion = false, options = {}) => {
        // 支持两种调用方式：
        // 1) submitMsg('text') - 经典字符串模式
        // 2) submitMsg({ question: 'text', multimodal_reference: {...} }) - 对象模式，包含引用
        let question = '';
        let extraParams = {};
        if (typeof msgOrParams === 'string') {
            question = msgOrParams;
        } else if (msgOrParams && typeof msgOrParams === 'object') {
            question = String(msgOrParams.question || '');
            // 将其他字段（如 multimodal_reference、references 等）保留到额外参数中
            extraParams = { ...msgOrParams };
            delete extraParams.question;
        } else {
            return false;
        }

        if (!isCanSendMsg(question, isPreQuestion)) {
            return false;
        }

        // 🔥 修改：使用提取的滚动函数
        scrollToBottomWithAnimation(listRef);

        const requestChatParams = {
            // character_setting: currentAgent?.character_setting,
            question: question,
            ...extraParams
        };
        // 如果存在 pending interrupt 标记，附加到参数并清除标记
        if (pendingInterruptFeedbackRef && pendingInterruptFeedbackRef.current) {
            requestChatParams.interrupt_feedback = pendingInterruptFeedbackRef.current;
            // 清除，确保只在下一次发送生效一次
            pendingInterruptFeedbackRef.current = null;
        }
        // 合并可选参数（用于 DeerFlow 等特殊控制字段）
        if (options && typeof options === 'object') {
            Object.assign(requestChatParams, options);
        }

        // 🔥 新增：如果有多模态学习引用，添加 reference_id 到请求参数
        if (multimodalReference && multimodalReference.reference_id) {
            requestChatParams.reference_id = multimodalReference.reference_id;
        }
        // 🔥 先发送消息（beforeSubmitMsg 会从 requestChatParams.multimodal_reference 读取并保存到消息中）
        onSubmitMsg(requestChatParams, isPreQuestion);
    };
    useEffect(() => {
        if (sessionId) {
            // 保留 search 参数进行跳转
            const search = props.searchParams ? `?${props.searchParams.toString()}` : '';
            props.navigate(`/web/o/${agentId}/chat${search}`);
        }
    }, []);
    const clickGuideS = (item) => {
        // 如果正在语音通话，弹出确认框
        if (item.link_target === 1) {
            if (showTTSComponent && !isInputVisible) {
                ConfirmTip({
                    icon: null,
                    title: '确认',
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '8px',
                                height: '84px',
                                paddingTop: '20px'
                            }}
                        >
                            <img src={Warning} style={{ width: '24px', height: '24px' }} />
                            <span>若切换新对话，将终止当前通话，请确认是否退出？</span>
                        </div>
                    ),
                    onOk: () => {
                        // 用户选择结束通话
                        try {
                            leaveRoom();
                            setContent('');
                        } catch (error) {
                            console.warn('离开房间时出现错误:', error);
                        }
                        handleBackToChat(); // 切换回输入框

                        // 确保在下一个事件循环中执行跳转，给SDK足够时间处理断开连接
                        Promise.resolve().then(() => {
                            clickGuide(item);
                        });
                    }
                });
                return;
            } else {
                clickGuide(item);
            }
        } else {
            clickGuide(item);
        }
    };

    // 创建包装版本的changeSession函数，在切换会话时关闭侧边栏
    const handleChangeSession = (session) => {
        // 如果正在语音通话，弹出确认框
        if (showTTSComponent && !isInputVisible) {
            ConfirmTip({
                icon: null,
                title: '确认',
                content: (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            height: '84px',
                            paddingTop: '20px'
                        }}
                    >
                        <img src={Warning} style={{ width: '24px', height: '24px' }} />
                        <span>若切换新对话，将终止当前通话，请确认是否退出？</span>
                    </div>
                ),
                onOk: () => {
                    // 用户选择结束通话
                    leaveRoom();
                    handleBackToChat(); // 切换回输入框
                    changeSession(session); // 执行切换
                }
            });
            return;
        }
        // console.log('session========session', session);
        changeSession(session);
        // deerFlowChatProps.handleChangeSession(changeSession)(session);
    };

    // 创建包装版本的choseApartSkill函数，在切换技能时关闭侧边栏
    const handleChoseApartSkill = (...args) => {
        // 如果正在语音通话，弹出确认框
        if (showTTSComponent && !isInputVisible) {
            ConfirmTip({
                icon: null,
                title: '确认',
                content: (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            height: '84px',
                            paddingTop: '20px'
                        }}
                    >
                        <img src={Warning} style={{ width: '24px', height: '24px' }} />
                        <span>若切换新对话，将终止当前通话，请确认是否退出？</span>
                    </div>
                ),
                onOk: () => {
                    // 用户选择结束通话
                    leaveRoom();
                    handleBackToChat(); // 切换回输入框
                    choseApartSkill(...args); // 执行切换
                }
            });
            return;
        }
        deerFlowChatProps.handleChangeSkill(choseApartSkill)(...args);
    };
    // 创建包装版本的startNewMsg函数，在开始新会话时关闭侧边栏
    const handleStartNewMsg = (...args) => {
        if (showTTSComponent && !isInputVisible) {
            ConfirmTip({
                icon: null,
                title: '确认',
                content: (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                            height: '84px',
                            paddingTop: '20px'
                        }}
                    >
                        <img src={Warning} style={{ width: '24px', height: '24px' }} />
                        <span>若切换新对话，将终止当前通话，请确认是否退出？</span>
                    </div>
                ),
                onOk: () => {
                    // 用户选择结束通话
                    leaveRoom();
                    handleBackToChat(); // 切换回输入框
                    choseApartSkill(...args); // 执行切换
                }
            });
            return;
        }
        deerFlowChatProps.handleStartNewSession(startNewMsg)(...args);
    };
    const handleChangeTool = async (tool) => {
        if (tool.id === toolId) {
            return;
        }
        let isLogin = await checkIsLogin();
        if (isLogin) {
            let searchStr = getSearchStr()
            deerFlowChatProps.handleChangeTool(changeTool, isLogin)(tool);
            props.navigate(`/web/o/${agentId}/tools/${tool.id}${searchStr}`);
        }
    };
    let getSkillIntroduction = () => {
        if (curSkill?.show_description) {
            return curSkill?.show_description;
        }
        if (curSkill?.third_json?.description) {
            return curSkill?.third_json?.description;
        }
        return curSkill?.show_name || curSkill?.ability_name;
    };
    const getAngetInfo = () => {
        let introduction = getSkillIntroduction();
        let name = curSkill?.show_name;
        return {
            introduction,
            name
        };
    };
    // 处理消息列表，添加对ReportNotice组件的支持
    const getItem = () => {
        let type = 'agent';
        let messages = sessionMap?.[sessionId]?.messages || [];
        let preQuestion = currentAgent?.pre_question_json;
        let agentInfo = currentAgent;
        let showGuide = true;
        let guideData = currentAgent?.user_agent_guide?.filter((ele) => ele?.enabled === 1) || [];
        //容错处理--后端返回的会话id有时会丢失，导致存在undefined:messages会话key
        if (!sessionId) {
            messages = [];
        }

        // 🔥 修改：只过滤掉真正需要隐藏的消息，保留思考过程消息
        messages = messages.filter((msg) => !msg.isHidden);

        // 🔥 关键修复：处理消息内容的安全检查，防止AIPPT对象污染其他技能
        messages = messages.map((msg, index) => {
            // 检查消息内容是否为对象
            if (msg.content && typeof msg.content === 'object' && !React.isValidElement(msg.content)) {
                // 🔥 修复：检查是否为AIPPT相关消息（通过content_type或handler字段判断）
                const isAIPPTMessage =
                    msg.content_type === 'aippt_catalog' ||
                    msg.content_type === 'aippt_cover' ||
                    msg.content_type === 'aippt_result' ||
                    msg.handler === 'aippt' ||
                    (msg.content.ongoing_status !== undefined &&
                        (msg.content.catalogs !== undefined ||
                            msg.content.theme !== undefined ||
                            msg.content.cover_image_list !== undefined ||
                            msg.content.images_url !== undefined));

                if (isAIPPTMessage) {
                    // 🔥 关键修复：AIPPT下架后，将对象数据转换为可读的字符串
                    let readableContent = '';

                    // 1️⃣ 主题选择阶段
                    if (msg.content.theme && !msg.content.catalogs) {
                        readableContent = `📝 PPT主题：${msg.content.theme}`;
                    }
                    // 2️⃣ 大纲确认阶段
                    else if (msg.content.catalogs && Array.isArray(msg.content.catalogs)) {
                        readableContent = `📋 PPT大纲：${msg.content.title || '未命名'}\n\n`;
                        msg.content.catalogs.forEach((catalog, idx) => {
                            readableContent += `${idx + 1}. ${catalog.catalog_name}\n`;
                            if (catalog.contents && Array.isArray(catalog.contents)) {
                                catalog.contents.forEach((content, cidx) => {
                                    readableContent += `   ${idx + 1}.${cidx + 1} ${content}\n`;
                                });
                            }
                        });
                    }
                    // 3️⃣ 模板选择阶段
                    else if (msg.content.cover_image_list && Array.isArray(msg.content.cover_image_list)) {
                        readableContent = `🎨 选择的模板：${msg.content.style || '默认风格'} - ${msg.content.color || '默认颜色'}`;
                    }
                    // 4️⃣ PPT生成结果
                    else if (msg.content.images_url || msg.content.id) {
                        readableContent = `✅ PPT已生成${msg.content.images_url ? '\n预览图：' + msg.content.images_url : ''}`;
                    }
                    // 5️⃣ 其他情况
                    else {
                        readableContent = `📄 AIPPT数据: ${JSON.stringify(msg.content, null, 2)}`;
                    }

                    return {
                        ...msg,
                        content: readableContent
                    };
                }

                // 其他类型的对象，转换为JSON字符串显示
                // 🔥 修复：过滤掉不应该传递给DOM的属性
                const { requestId, pptId, apiData, messageType, loading, loadingId, sessionId, _id, task_id, threadId, session_id, ...cleanMsg } =
                    msg;
                return {
                    ...cleanMsg,
                    content: `📄 数据: ${JSON.stringify(msg.content)}`
                };
            }
            return msg;
        });

        //隔离技能显示技能的预设问题和技能描述信息,未显示的技能，不显示预设问题
        if (curSkill?.ability_id != -1) {
            type = 'skill';
            showGuide = false;
            preQuestion = skillPreQuestion;
            agentInfo = getAngetInfo();
        }

        // 处理消息内容中的报告通知卡片
        let processedMessages = processDeerFlowMessages(messages, sessionId, deerFlowChatProps, style);
        // processedMessages = simulation.showCaseCard ? [] : processedMessages;
        return [
            {
                avatar: <img className={s['ai-avatar']} src={currentAgent?.agent_icon}></img>,
                variant: 'borderless',
                role: 'pre',
                content: (
                    <PreQuestion
                        sessionId={sessionId}
                        isCaseSimulation={isCaseSimulation}
                        disabled={!skillStore.skillAvailable}
                        type={type}
                        guideData={guideData}
                        showGuide={showGuide}
                        curSkill={curSkill}
                        clickGuide={clickGuide}
                        clickGuideS={clickGuideS}
                        pre_question_json={preQuestion}
                        submitMsg={submitMsg}
                        currentAgent={agentInfo}
                        isTTSMode={showTTSComponent && !isInputVisible}
                    ></PreQuestion>
                )
            },

            ...processedMessages
        ];
    };

    // 修改返回JSX部分，始终保持组件挂载但使用CSS过渡效果显示/隐藏
    const shouldRenderAippt = () => {
        // 🔥 检查 sessionMap 中的消息是否包含 AIPPT 内容
        const hasAipptInSessionMap =
            sessionId && sessionMap?.[sessionId]?.messages?.some((msg) => msg.content_type && msg.content_type.startsWith('aippt_'));

        // 🔥 检查 originMsgMapRef 中的消息是否包含 AIPPT 内容（实时SSE消息）
        const hasAipptInOriginMap =
            sessionId && originMsgMapRef?.current?.[sessionId]?.messages?.some((msg) => msg.content_type && msg.content_type.startsWith('aippt_'));

        // 🔥 判断是否应该渲染 AIPPT 组件
        const shouldRenderAippt = curSkill?.third_json?.handler === 'aippt' || hasAipptInSessionMap || hasAipptInOriginMap;

        return shouldRenderAippt;
    };
    return (
        <>
            <div
                className={s['web-chats-box']}
                id="grt-chat-box"
                ref={chatBoxRef}
                data-theme={themeMap[style?.themeColor]}
                data-sidebar-open={deerFlowChatProps.sidebarOpen ? 'true' : 'false'}
                data-detail-panel-open={detailPanelOpen ? 'true' : 'false'}
            >
                <Display show={agentLoading}>
                    <GrtLoading spinning={true}></GrtLoading>
                </Display>
                <Display show={!agentLoading}>
                    <Display show={currentAgent.error}>
                        <AgentError err={currentAgent}></AgentError>
                    </Display>

                    <Display show={!currentAgent.error}>
                        <div className={s['left']}>
                            <div className={s['agent-name']}>
                                <AgentLogo theme={style?.themeColor}></AgentLogo>
                                <span>{currentAgent.name}</span>
                                {/* <span className={s['agent-tip']}>
                                    <Tooltip placement="right" title={currentAgent?.description}>
                                        <span>
                                            <InfoCircleOutlined />
                                        </span>
                                    </Tooltip>
                                </span> */}
                            </div>
                            <div
                                className={s['left-scroll']}
                                onMouseEnter={(e) => {
                                    e.target.classList.add('scroll-hover');
                                }}
                                onMouseLeave={(e) => {
                                    e.target.classList.remove('scroll-hover');
                                }}
                            >
                                <ApartSkillList
                                    chatBoxRef={chatBoxRef}
                                    isInChat={toolId ? false : true}
                                    isNewChat={!sessionId}
                                    curSkill={curSkill}
                                    setCurSkill={handleChoseApartSkill}
                                    skillListRef={skillListRef}
                                    skillList={skillList.apartList}
                                ></ApartSkillList>
                                <ToolList
                                    chatBoxRef={chatBoxRef}
                                    toolList={currentAgent?.scene_tool}
                                    curToolId={toolId}
                                    changeTool={handleChangeTool}
                                ></ToolList>
                                <div className={s['border-box']}></div>
                                <div className={s['session-list']}>
                                    <SessionList
                                        userId={userId}
                                        isLogin={isLogin}
                                        sessionId={sessionId}
                                        resetSession={resetSession}
                                        changeSession={handleChangeSession}
                                        getHistorySessionList={getHistorySessionList}
                                    ></SessionList>
                                </div>
                            </div>

                            <div
                                className={s['agent-figure']}
                                onMouseLeave={() => {
                                    setShowAgentTip(false);
                                }}
                                onMouseEnter={() => {
                                    if (!showAgentModal) {
                                        setShowAgentTip(true);
                                    }
                                }}
                                onClick={() => {
                                    setShowAgentTip(false);
                                    setShowAgentModal(true);
                                }}
                            >
                                <Modal
                                    width={560}
                                    maskClosable={false}
                                    footer={null}
                                    open={showAgentModal}
                                    onCancel={(e) => {
                                        e.stopPropagation();
                                        setShowAgentModal(false);
                                    }}
                                >
                                    <div className={s['agent-modal-content']}>
                                        <div className={s['agent-modal-avatar']}>
                                            <img className={s['hi-img']} src={hiImg} alt="" />
                                            <img className={s['agent-icon']} src={currentAgent?.agent_icon} alt="" />
                                        </div>
                                        <div className={s['agent-modal-title']}>我是{currentAgent?.name}，看看我能做些什么吧</div>
                                        <div className={s['agent-modal-desc']} data-empty={!currentAgent?.description}>
                                            {currentAgent?.description || '还没来得及写简介，直接和我开始对话吧～'}
                                        </div>
                                    </div>
                                </Modal>
                                <Hide show={showAgentTip}>
                                    <div className={s['prompt-text-wrap']}>
                                        <div className={s['prompt-text']}> 戳我，认识一下</div>
                                        <img className={s['prompt-text-img']} src={agentTipBgImg[style.themeColor]} alt="" />
                                        <div className={`${s['pulse-cilcle']}`}>
                                            <CircleBlink></CircleBlink>
                                        </div>
                                        <img className={s['prompt-text-hand']} src={tipHandImg} alt="" />
                                    </div>
                                </Hide>

                                <div className={s['grow-box']}></div>
                                <div className={s['bg-box']}>
                                    <img src={figureImg[style.themeColor]} alt="" />
                                </div>
                                <img className={s['agent-figure-img']} src={currentAgent?.agent_figure} alt="" />
                            </div>
                            <UserInfo></UserInfo>
                        </div>

                        <div
                            className={`${s['right']} ${deerFlowChatProps.sidebarOpen ? s['with-sidebar'] : ''} ${detailPanelOpen ? 'detail-panel-open' : ''
                                }`}
                            ref={chatRef}
                            style={{ overflowY: 'hidden' }} // 禁止垂直滚动，无论侧边栏是否打开
                        >
                            <Hide show={toolId}>
                                <Outlet></Outlet>
                            </Hide>
                            <Hide show={!toolId}>
                                <Display show={style?.webBgUrl && !style?.webBgUrl.includes('pre_1')}>
                                    <img className={s['right-bg']} src={style?.webBgUrl} alt="" />
                                </Display>
                                <Display show={recordLoading}>
                                    <div className={s['loading-div']}>
                                        <Spin spinning={recordLoading}></Spin>
                                    </div>
                                </Display>
                                <Display show={!recordLoading}>
                                    <Display show={!curSkill?.ability_id}></Display>
                                    <Display show={curSkill?.ability_id}>
                                        <div
                                            className={`${s['chat-content']} ${deerFlowChatProps.sidebarOpen ? s['with-sidebar'] : ''}`}
                                            key={sessionId}
                                            data-sidebar-open={deerFlowChatProps.sidebarOpen ? 'true' : 'false'}
                                            style={{ overflowY: 'hidden' }} // 禁止垂直滚动，无论侧边栏是否打开
                                        >
                                            <Display show={curSkill?.third_json?.handler === 'chatbi'}>
                                                <ChatBI {...chatProps} chatBIRef={chatBIRef} agentId={agentId} />
                                            </Display>
                                            <Display show={shouldRenderAippt()}>
                                                <AIPPTContainer
                                                    skillStore={skillStore}
                                                    checkIsLogin={checkIsLogin}
                                                    sessionId={sessionId}
                                                    curSkill={curSkill}
                                                    setCurSkill={setCurSkill}
                                                    sessionMap={sessionMap}
                                                    currentAgent={currentAgent}
                                                    loading={loading}
                                                    content={content}
                                                    setContent={setContent}
                                                    skillList={skillList}
                                                    curPlugin={curPlugin}
                                                    setCurPlugin={setCurPlugin}
                                                    submitMsg={submitMsg}
                                                    skillPreQuestion={skillPreQuestion}
                                                    clickGuide={clickGuide}
                                                    agentFile={agentFile}
                                                    setAgentFile={setAgentFile}
                                                    agentFileRef={agentFileRef}
                                                    style={style}
                                                    editPlanMode={editPlanMode}
                                                    toggleEditPlanMode={toggleEditPlanMode}
                                                    resetEditPlanMode={resetEditPlanMode}
                                                    isInputVisible={isInputVisible}
                                                    showTTSComponent={showTTSComponent}
                                                    showChatInterface={showChatInterface}
                                                    onTTSToggle={handleTTSToggle}
                                                    stopDeerFlow={stopDeerFlow}
                                                    generatingReports={deerFlowChatProps.generatingReports}
                                                    sidebarOpen={deerFlowChatProps.sidebarOpen}
                                                    activeReportId={deerFlowChatProps.activeReportId}
                                                    handleStartNewMsg={handleStartNewMsg}
                                                    sessionStatus={originMsgMap?.current?.[sessionId]?.status}
                                                    agentId={agentId}
                                                    getHistorySessionList={getHistorySessionList}
                                                    linkToSession={linkToSession}
                                                    formatSessionList={formatSessionList}
                                                    sessionListRef={sessionListRef}
                                                    handleMessages={handleMessages}
                                                    changeSessionMapItem={changeSessionMapItem}
                                                    changeOriginMsgMapRef={changeOriginMsgMapRef}
                                                    originMsgMapRef={originMsgMap}
                                                    handleGetSessionMessage={handleGetSessionMessage}
                                                />
                                            </Display>
                                            <Display show={!shouldRenderAippt() && curSkill?.third_json?.handler !== 'chatbi'}>
                                                <>
                                                    <div className={s['chats-box']}>
                                                        {/* 🌟 消息列表 */}
                                                        {/* <PreQuestion onSubmitMsg={onSubmitMsg} currentAgent={currentAgent}></PreQuestion> */}
                                                        <Bubble.List
                                                            autoScroll={sessionId ? true : false}
                                                            ref={listRef}
                                                            key={sessionId}
                                                            items={getItem()}
                                                            roles={getRoles(
                                                                sessionMap?.[sessionId]?.loading,
                                                                <img className={s['ai-avatar']} src={currentAgent?.agent_icon}></img>
                                                            )}
                                                            className={`${s['chats-web-messages']} ${curSkill?.third_json?.handler === 'deerflow' ? s['deerflow-messages'] : ''
                                                                } ${detailPanelOpen ? s['detail-panel-open-messages'] : ''} ${simulation.showCaseCard ? s['case-simulation-card'] : ''
                                                                }`}
                                                        />
                                                        <Display show={isCaseSimulation}>
                                                            <Display show={!sessionId || (sessionId && simulation.showCaseCard)}>
                                                                <UserCards
                                                                    simulation={simulation}
                                                                    setShowCaseCard={simulation.setShowCaseCard}
                                                                    onSubmitMsg={onSubmitMsg}
                                                                    curSkill={curSkill}
                                                                />
                                                            </Display>
                                                            <Display show={sessionId}>
                                                                <CardButton
                                                                    setShowCaseCard={simulation.setShowCaseCard}
                                                                    expand={simulation.showCaseCard}
                                                                />
                                                            </Display>
                                                        </Display>
                                                    </div>
                                                    {/* 🌟 输入框 */}
                                                    <Display show={showChatInterface && !isCaseSimulation}>
                                                        <div
                                                            className={`${s['input-wrap']} ${deerFlowChatProps.sidebarOpen ? s['with-sidebar'] : ''}`}
                                                        >
                                                            <Display show={!skillStore.skillAvailable}>
                                                                <div
                                                                    onClick={() => {
                                                                        Toast.info('该技能暂不可用');
                                                                    }}
                                                                    className={s['unavailable-box']}
                                                                ></div>
                                                            </Display>
                                                            {/* 🌟 提示词 */}

                                                            {/* 🔥 修复：只有当 curSkill 在当前技能列表中时才显示技能列表 */}
                                                            {/* 这样可以防止打开已下架技能的旧会话时，仍然显示技能列表的问题 */}
                                                            <Display
                                                                show={
                                                                    skillStore.skillAvailable &&
                                                                    skillList?.unApartList?.length &&
                                                                    (curSkill?.left_side === 1 || curSkill?.left_side === 2)
                                                                }
                                                            >
                                                                <SkillList
                                                                    themeColor={style.themeColor}
                                                                    show={curSkill && (curSkill?.left_side !== 1 || curSkill?.ability_id == -1)}
                                                                    curSkill={curSkill}
                                                                    setCurSkill={setCurSkill}
                                                                    skillList={skillList.unApartList}
                                                                ></SkillList>
                                                            </Display>

                                                            <WebSender
                                                                multimodalReference={multimodalReference}
                                                                setMultimodalReference={setMultimodalReference}
                                                                setAgentFile={setAgentFile}
                                                                themeColor={style.themeColor}
                                                                placeholder={editPlanMode ? '你想怎么修改方案?' : curSkill?.default_prompt}
                                                                startNewSession={handleStartNewMsg}
                                                                value={content}
                                                                plugins={curSkill?.ability_id == -1 ? defaultPlugins : curSkill?.plugin_json || []}
                                                                onSubmit={submitMsg}
                                                                onChange={setContent}
                                                                loading={sessionMap?.[sessionId]?.loading || sessionMap?.[sessionId]?.answering}
                                                                editPlanMode={editPlanMode}
                                                                exitEditPlanMode={resetEditPlanMode}
                                                                sessionId={sessionId}
                                                                onStop={deerFlowChatProps.getStopCallback()}
                                                                stopHistoryPolling={stopHistoryPolling}
                                                                activeReportId={deerFlowChatProps.getActiveReportId()}
                                                                handlePaste={handlePaste}
                                                                skillStore={skillStore}
                                                            ></WebSender>
                                                        </div>
                                                    </Display>
                                                    {/* 语言对话样式 */}
                                                    <Display show={!showChatInterface}>
                                                        {/* 开启视频共享屏幕对话 */}
                                                        <CameraArea forceShow={showCameraArea} />
                                                        <div className="toolbar-container">
                                                            {/* 语言挂断 */}
                                                            <ToolBar
                                                                sessionId={sessionId}
                                                                originMsgMapRef={originMsgMapRef}
                                                                TTSNewMsg={TTSNewMsg}
                                                                onBackToChat={handleBackToChat}
                                                                ttsMessagesRef={ttsMessagesRef}
                                                                ttsContentRef={ttsContentRef}
                                                                currentAgent={currentAgent}
                                                                resetVoiceCallStatus={resetVoiceCallStatus}
                                                                hideTTSActions={hideTTSActions}
                                                                setHideTTSActions={setHideTTSActions}
                                                            />
                                                            {/* //音频样式 */}
                                                            {/* <AudioController className={styleTTS.controller} /> */}
                                                        </div>
                                                    </Display>
                                                </>
                                            </Display>

                                            {curSkill?.third_json?.handler !== third_json_handler.aippt && (
                                                <div className="ai-mark">
                                                    <AIMarks index={0} />
                                                </div>
                                            )}
                                        </div>
                                    </Display>
                                </Display>
                            </Hide>
                        </div>
                    </Display>
                </Display>
                {/* 侧边栏 */}
                <DeerFlowSidebar deerFlowChatProps={deerFlowChatProps} style={style} s={s} />
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(WebOutsideChats)));
